import { render, staticRenderFns } from "./MidasPay.vue?vue&type=template&id=56b0d2c0&"
import script from "./MidasPay.vue?vue&type=script&lang=js&"
export * from "./MidasPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports